import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    status: {
      textTransform: 'uppercase',
      // not available in material-ui, should we add it?
      fontSize: '0.625rem',
      fontWeight: 500,
      borderRadius: '16px',
      padding: theme.spacing(0, 1),
      marginLeft: theme.spacing(),
    },
    statusRejected: {
      backgroundColor: '#EC1C24',
      color: theme.palette.common.white,
    },
    statusProposed: {
      backgroundColor: '#FDD835',
      color: theme.palette.common.black,
    },
    statusApproved: {
      backgroundColor: '#43A047',
      color: theme.palette.common.white,
    },
  };
};
